<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
            <div class="frequency">
              <PaymentOptions addMonthly />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="My contribution is in honor of:">
            <div>
              <FormRow
                class="designation-form-row"
                v-for="(item, index) in designations"
                :key="index"
              >
                <label :for="'designation_' + index" class="pre-dinner__label">
                  <input
                    type="checkbox"
                    :id="'designation_' + index"
                    :value="item.value"
                    class="pre-dinner__checkbox pre-dinner__designations"
                    :checked="checkedDesignations.includes(item.value)"
                    @click="toggleDesignation(item.value, $event.target.checked)"
                    ref="index === designations.length - 1 ? otherCheckbox : null"
                  />
                  <span class="pre-dinner__text">{{ item.label }}</span>
                </label>
                <FormRow
                  v-if="
                    index === designations.length - 1 &&
                    checkedDesignations.includes(item.value)
                  "
                  class="full-width"
                >
                  <div style="width: 100%">
                    <FormLabel class="control-label"> In honor of: </FormLabel>
                    <input
                      type="text"
                      class="width-full"
                      v-model="honorOf"
                      ref="otherTextInput"
                    />
                  </div>
                </FormRow>
              </FormRow>
            </div>
          </FormSection>          
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
          </FormRow>            
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt />
            </FormRow>               
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton btnText="Donate Now" showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  computed,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm();

    const honoOtherrOf = ref("");
    const honorOf = ref("");
    const otherCheckbox = ref<HTMLInputElement | null>(null);
    const otherTextInput = ref<HTMLInputElement | null>(null);

    const designations = [
      { label: 'Rebbetzin Elaine and Rabbi Pinchas Stolper a"h', value: 'Rebbetzin Elaine and Rabbi Pinchas Stolper a"h' },
      { label: 'Ari Kahn a"h Memorial Fund', value: 'Ari Kahn a"h Memorial Fund' },
      { label: 'Eddie Adler HY"D', value: 'Eddie Adler HY"D' },
      { label: 'Mikey Butler a"h', value: 'Mikey Butler a"h' },
      { label: 'Moses I. Feuerstein a"h', value: 'Moses I. Feuerstein a"h' },
      { label: 'Aviva Sontag Ghatan a"h', value: 'Aviva Sontag Ghatan a"h' },
      { label: 'Asher Ahron Gross HY"D', value: 'Asher Ahron Gross HY"D' },
      { label: 'Rabbi Alan Kuperman a"h', value: 'Rabbi Alan Kuperman a"h' },
      { label: 'Rabbi David Kaminetsky a"h', value: 'Rabbi David Kaminetsky a"h' },
      { label: 'Ezra Lightman a"h', value: 'Ezra Lightman a"h' },
      { label: 'Julia and Joseph Macy a"h', value: 'Julia and Joseph Macy a"h' },
      { label: 'Rabbi Ralph Pelcovitz a"h', value: 'Rabbi Ralph Pelcovitz a"h' },
      { label: 'Anne Samson a"h', value: 'Anne Samson a"h' },
      { label: 'Leah Weiner a"h', value: 'Leah Weiner a"h' },


      { label: "Other", value: "Other" },
    ];
    let checkedDesignations = ref<string[]>([]);
    const firstCheckbox = ref<HTMLInputElement | null>(null);
    const honoreesDesignation = ref("");

    const toggleDesignation = (value: string, checked: boolean) => {
      if (checked) {
        if (!checkedDesignations.value.includes(value)) {
          checkedDesignations.value.push(value);
        }
      } else {
        checkedDesignations.value = checkedDesignations.value.filter(v => v !== value);
      }
    };

    watch(checkedDesignations, () => {
      let tempArray = [];
      let honorString = honorOf.value + checkedDesignations.value;
      tempArray = honorString.split(",")
      const index = tempArray.indexOf("Other");
      if (index > -1) { 
        tempArray.splice(index, 1); 
        //@ts-ignore
        setValue("custom.honorOf", tempArray);
      } else {
        //@ts-ignore
        setValue("custom.honorOf", checkedDesignations.value);
      }      
    });

    watch(honorOf, () => {
      let tempArray = [];
      let honorString = honorOf.value + checkedDesignations.value;
      tempArray = honorString.split(",")
      const index = tempArray.indexOf("Other");
      if (index > -1) { 
        tempArray.splice(index, 1); 
        //@ts-ignore
        setValue("custom.honorOf", tempArray);
      } else {
        //@ts-ignore
        setValue("custom.honorOf", checkedDesignations.value);
      }   
    })


    return {
      form,
      setValue,
      designations,
      checkedDesignations,
      toggleDesignation,
      firstCheckbox,
      honoreesDesignation,
      honorOf,
      otherCheckbox,
      otherTextInput,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
  position: relative;
  &:not(:empty) {
    &::before {
      content: "*";
      color: #e87d2d;
      margin-right: 3px;
    }
  }
}
</style>
